import { render, staticRenderFns } from "./chartBarAverage.pug?vue&type=template&id=1ba4296a&lang=pug&"
import script from "./chartBarAverage.js?vue&type=script&lang=js&"
export * from "./chartBarAverage.js?vue&type=script&lang=js&"
import style0 from "./chartBarAverage.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/macmaum1/Desktop/GARAJE/mavalue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ba4296a')) {
      api.createRecord('1ba4296a', component.options)
    } else {
      api.reload('1ba4296a', component.options)
    }
    module.hot.accept("./chartBarAverage.pug?vue&type=template&id=1ba4296a&lang=pug&", function () {
      api.rerender('1ba4296a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adminLayout/views/charts/components/chartBarAverage/index.vue"
export default component.exports